import React from 'react';
import { ShieldCheck, Settings, Factory, Gauge, CheckCircle } from 'lucide-react';
import work from '../../assets/images/about1.jpg';

const TechnicalExpertise = () => {
  return (
    <section className="technical-expertise py-5 bg-white overflow-hidden">
      <div className="container py-lg-5">
        <div className="row g-5 align-items-center">
          
          {/* Left Column: Visual Impact */}
          <div className="col-lg-5 position-relative" data-aos="fade-right">
            <div className="img-wrapper rounded-4 shadow-lg overflow-hidden position-relative">
              <img 
                src={work}
                alt="HT/LT Substation Infrastructure" 
                className="img-fluid img-hover-zoom"
              />
              
              {/* Floating Performance Badge */}
              <div className="position-absolute top-0 start-0 m-4 glass-badge p-3 rounded-4 text-white shadow-lg">
                <div className="d-flex align-items-center gap-2">
                  <Gauge size={20} />
                  <span className="fw-bold">99.9% Uptime</span>
                </div>
              </div>

              {/* Floating Safety Badge */}
              <div className="position-absolute bottom-0 end-0 glass-badge p-4 rounded-4 shadow-lg text-white m-4 d-none d-md-block" style={{maxWidth: '260px'}}>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <ShieldCheck size={28} />
                  <h5 className="mb-0 fw-bold">Safety Certified</h5>
                </div>
                <p className="small mb-0 opacity-90">
                  Zero-accident record across all 50+ project sites.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: Technical Details */}
          <div className="col-lg-6 ps-lg-5" data-aos="fade-left">
            <div className="mb-4">
              <h6 className="green text-uppercase fw-bold tracking-wider mb-2">Technical Excellence</h6>
              <h2 className="display-5 fw-bold text-dark mb-4">
                Engineering Infrastructure <br />
                <span className="green">Built for MNCs</span>
              </h2>
              <p className="text-muted mb-5">
                Denial Enterprise bridges the gap between high-voltage engineering machinery 
                and sustainable energy hubs for multinational corporations.
              </p>
            </div>

            {/* Feature 1: Infrastructure */}
            <div className="expertise-card d-flex gap-4 p-4 rounded-4 mb-3 shadow-sm bg-white">
              <div className="icon-box icon-filter bg-lightgreen-subtle p-3 rounded-3 text-success d-flex align-items-center justify-content-center" style={{minWidth: '60px', height: '60px'}}>
                <Settings size={30} />
              </div>
              <div>
                <h5 className="fw-bold mb-2">Advanced Technical Infrastructure</h5>
                <p className="text-muted small mb-0">
                  We utilize industrial-grade transformers and cable insulation resistance testers 
                  to ensure long-term reliability for every deployment.
                </p>
              </div>
            </div>

            {/* Feature 2: Compliance */}
            <div className="expertise-card d-flex gap-4 p-4 rounded-4 mb-3 shadow-sm bg-white">
              <div className="icon-box icon-filter bg-lightgreen-subtle p-3 rounded-3 text-success d-flex align-items-center justify-content-center" style={{minWidth: '60px', height: '60px'}}>
                <CheckCircle size={30} />
              </div>
              <div>
                <h5 className="fw-bold mb-2">DISCOM Compliance Standards</h5>
                <p className="text-muted small mb-0">
                  All infrastructure is built in strict accordance with Gujarat Electricity Board (GEB) 
                  and international safety regulations.
                </p>
              </div>
            </div>

            {/* Feature 3: Vendor Status */}
            <div className="expertise-card d-flex gap-4 p-4 rounded-4 shadow-sm bg-white">
              <div className="icon-box icon-filter bg-lightgreen-subtle p-3 rounded-3 text-success d-flex align-items-center justify-content-center" style={{minWidth: '60px', height: '60px'}}>
                <Factory size={30} />
              </div>
              <div>
                <h5 className="fw-bold mb-2">Tier-1 MNC Vendor</h5>
                <p className="text-muted small mb-0">
                  Trusted by Finance Managers and Directors to manage complex substation building 
                  and HT/LT connectivity projects.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TechnicalExpertise;